export default __webpack_public_path__ + "static/media/American Amicable.72306424.svg";